import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import styles from './TabBar.module.css';
const SELECTABLE_ROLES = ['gridcell', 'option', 'row', 'tab'];
const Tab = ({ children, className = '', isSelected, role = 'tab', onClick, onUpdateSelected, setRef }) => {
    const liRef = useRef(null);
    useEffect(() => {
        if (liRef.current) {
            setRef === null || setRef === void 0 ? void 0 : setRef(liRef.current);
        }
    }, [setRef]);
    useEffect(() => {
        if (liRef.current && isSelected) {
            onUpdateSelected === null || onUpdateSelected === void 0 ? void 0 : onUpdateSelected(liRef.current);
        }
    }, [isSelected, onUpdateSelected]);
    const aria = SELECTABLE_ROLES.includes(role)
        ? {
            'aria-selected': isSelected
        }
        : {};
    return (React.createElement("li", Object.assign({}, aria, { ref: liRef, className: cx(styles.item, className, {
            [styles.active]: isSelected
        }), role: role }), React.Children.map(children, (child) => React.cloneElement(child, {
        onClick: (evt) => {
            var _a, _b;
            onClick === null || onClick === void 0 ? void 0 : onClick(liRef.current);
            (_b = (_a = child.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
        }
    }))));
};
export default Tab;
//# sourceMappingURL=Tab.js.map